import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import api from "../lib/api";
import SectionHeader from "../components/SectionHeader";
import { Quote, Star } from "lucide-react";

export default function TestimonialsPage() {
  const { t } = useTranslation();
  const [items, setItems] = useState([]);

  useEffect(() => { api.get("/testimonials").then(({ data }) => setItems(data)).catch(() => {}); }, []);

  return (
    <div data-testid="testimonials-page" className="pb-24">
      <section className="border-b border-slate-800 py-20">
        <div className="max-w-7xl mx-auto px-5 lg:px-8">
          <SectionHeader kicker="CLIENT VOICE" title={t("testimonials.title")} description={t("testimonials.subtitle")} testIdPrefix="testimonials" />
        </div>
      </section>

      <section className="py-16">
        <div className="max-w-7xl mx-auto px-5 lg:px-8 grid md:grid-cols-2 gap-0 border border-slate-800 grid-border">
          {items.map((t) => (
            <figure key={t.id} data-testid={`testimonial-${t.id}`} className="p-10 bg-slate-950 hover:bg-slate-900 transition-colors">
              <Quote size={24} className="text-amber-400" />
              <blockquote className="mt-5 font-display text-xl text-white leading-relaxed">“{t.quote}”</blockquote>
              <div className="mt-6 flex items-center gap-1">
                {Array.from({ length: t.rating || 5 }).map((_, i) => <Star key={i} size={14} className="text-amber-400 fill-amber-400" />)}
              </div>
              <figcaption className="mt-4">
                <div className="font-bold text-white">{t.name}</div>
                <div className="text-sm text-slate-400">{t.designation} · {t.company}</div>
                <div className="mt-1 font-mono-spec text-[10px] text-blue-400">{t.industry}</div>
              </figcaption>
            </figure>
          ))}
        </div>
      </section>
    </div>
  );
}
